module.exports = __webpack_public_path__ + "static/media/lavabos.d9da812f.svg";